module.exports = __webpack_public_path__ + "static/media/10n.ec256988.png";